import $, { map } from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import fb from "@bd-core/firebase";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import Screen from "@bd-utils/screen";
import { getState } from "@bd-stores/store";
import {
    getRoomStatus,
    getPlayers,
    getFinalTeamAnswers,
} from "@bd-stores/game-progress";
import { updateFinalRoomAnswer } from "@bd-core/firebase-actions";
import bdapi from "@bd-core/bd-api";
import gsap from "gsap";
import Draggable from "gsap/Draggable";
import GameLogic from "@bd-core/game-logic";

export class MainRoom extends BD_Component {
    constructor() {
        super();

        this.id = "main-room";
        this.templateID = "main-room-template";

        this.elms = {
            btnFinishGame: ".js-finish-game",
            background: ".js-screen-img",
            backgroundImage: ".screen__img",
            zoomIn: ".js-zoom-in",
            zoomOut: ".js-zoom-out",
            hintItem: ".js-hint",
            audioItem: ".js-audio",
            audioItemFile: ".js-audio-file",
            mainRoomItem: ".js-mainroom-item",
            closeMainRoomPopup: ".js-close-mainroom-popup",
        };

        this._events = this.getEvents();
        this.fbListeners = [];

        this.startX = 0;
        this.startY = 0;
        this.zoom = 100;
        this.backgroundWidth = 5760;
        this.backgroundHeight = 2160;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.btnFinishGame,
                handler: this.finishGame,
            },
            {
                event: "click",
                selector: elms.zoomIn,
                handler: this.onZoomIn,
            },
            {
                event: "click",
                selector: elms.zoomOut,
                handler: this.onZoomOut,
            },
            {
                event: "change",
                selector: elms.hintItem,
                handler: this.onClickedHint,
            },
            {
                event: "click",
                selector: elms.audioItem,
                handler: this.onClickAudio,
            },
            {
                event: "click",
                selector: elms.mainRoomItem,
                handler: this.openPopup,
            },
            {
                event: "click",
                selector: elms.closeMainRoomPopup,
                handler: this.closePopup,
            },
        ];
    }

    beforeInit() {
        window.screenCalculationFunc = () => Screen.calculateCoverSize();

        this.forceOpenChallenge();
        this.render();
        this.setGameState();
        this.listenFinishedUsers();
    }

    modifiedData() {
        const data = this._data;

        if (Object.keys(data).length == 0) return {};

        map(data.rooms, (room) => {
            let is_main_room = false;

            if (room.hotspot_type == "room") {
                is_main_room = true;
            }

            if (room.hotspot_type == "hint") {
                const font_fam = room.hint_font_family.split("|");
                const font_name = font_fam[0];
                const font_category = font_fam[1];

                room.font_family = `"${font_name}", ${font_category}`;
            }

            room.isMainRoom = is_main_room;

            return room;
        });

        let data_rooms = [];
        data.rooms.forEach((room) => {
            if (room.mainroom_id == data.room_id) {
                data_rooms.push(room);
            }
        });

        return {
            ...data,
            rooms: data_rooms,
        };
    }

    render() {
        const data = this.modifiedData();
        const mainroomStyle = data.mainroom_style;
        let templateID = "main-room-template";

        if (typeof mainroomStyle == "string") {
            templateID = mainroomStyle + "-template";
        }

        const htmlTemplate = $("#" + templateID).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);
    }

    setGameState() {
        const roomID = this.roomId;
        const currentPlayerId = CONFIG.user.id;
        const usersStateFinish = getFinalTeamAnswers(roomID);

        if (usersStateFinish) {
            const finishState = bdjs.indexedObjectToArray(usersStateFinish);
            const myState = finishState.find((uID) => uID == currentPlayerId);

            if (myState) {
                const waitingText = $(".waiting-others-text").text();
                const $finishBtn = $(this.elms.btnFinishGame);

                $finishBtn.addClass("is-waiting");
                $finishBtn.find("span").text(waitingText);
            }
        }

        const gameProgress = getState().gameProgress;
        const roomStatuses = gameProgress.roomStatus;
        const isAllRoomCompleted = gameProgress.allRoomCompleted;

        $.each(roomStatuses, function (roomID, status) {
            if (status === "is-status-completed") {
                $(`.js-mainroom-item[data-page="${roomID}"]`).addClass(
                    "is-completed",
                );
            }
        });

        if (isAllRoomCompleted) {
            $("#page-mainroom").addClass("is-room-completed");

            setTimeout(() => {
                $(this.elms.btnFinishGame).trigger("click");
            }, 500);
        }

        this.updateRoomRequirements();

        $(this.elms.backgroundImage).on("load", () => {
            if ($(this.elms.backgroundImage).hasClass("js-draggable")) {
                this.initBackground();
                this.setMoveable();
                $(window).on("resize", () => {
                    this.resetDraggableParams();
                });
            }
        });
    }

    // ============================== CUSTOM FUNCTION

    openPopup(e, el) {
        e.preventDefault();

        const $roomItem = $(".js-mainroom-item");
        const isCompleted = $(el).hasClass("is-completed");

        if (isCompleted) return;

        $roomItem.removeClass("is-active");
        $(el).addClass("is-active");
    }

    closePopup(e, el) {
        e.stopPropagation();
        const $roomItem = $(el).parents(".js-mainroom-item");

        $roomItem.removeClass("is-active");
        $roomItem.addClass("is-transitioning");

        setTimeout(function () {
            $roomItem.removeClass("is-transitioning");
        }, 300);
    }

    initBackground() {
        let backWidth = $(this.elms.backgroundImage).prop("naturalWidth"),
            backHeight = $(this.elms.backgroundImage).prop("naturalHeight");
        this.backgroundWidth = !backWidth ? 4096 : backWidth;
        this.backgroundHeight = !backHeight ? 1536 : backHeight;
        setTimeout(() => {
            $(this.elms.backgroundImage).removeAttr("style");
            $(this.elms.background).removeAttr("style");
            $(".js-draggable").css({
                width: `${this.backgroundWidth}px`,
                height: `${this.backgroundHeight}px`,
            });
        }, 400);
    }

    resetDraggableParams() {
        $(".js-draggable").css({
            width: `${this.backgroundWidth}px`,
            height: `${this.backgroundHeight}px`,
            transform: `translate(-50%, -50%)`,
        });
        this.startX = 0;
        this.startY = 0;
        gsap.set(".js-draggable", { clearProps: "transform" });
    }

    onZoomIn() {
        if (this.zoom < 120) {
            this.zoom += 5;
            this.backgroundWidth += this.backgroundWidth * 0.05;
            this.backgroundHeight += this.backgroundHeight * 0.05;
            this.resetDraggableParams();
        }
    }

    onZoomOut() {
        if (this.zoom > 100) {
            this.zoom -= 5;
            this.backgroundWidth -= this.backgroundWidth * 0.05;
            this.backgroundHeight -= this.backgroundHeight * 0.05;
            this.resetDraggableParams();
        }
    }

    setMoveable() {
        gsap.registerPlugin(Draggable);
        let companions;

        Draggable.create(".js-draggable", {
            bounds: $(".screen__container"),
            dragResistance: 0.5,
            edgeResistance: 1,
            allowContextMenu: true,
            type: "x,y",
            zIndexBoost: false,
            onPress: function () {
                const screens = document.querySelectorAll(".js-draggable");
                let i = screens.length;
                companions = [];
                MainRoom.prototype.startX = this.x;
                MainRoom.prototype.startY = this.y;
                while (--i > -1) {
                    if (companions[i] !== this.target) {
                        companions.push({
                            element: screens[i],
                            x: gsap.getProperty(screens[i], "x"),
                            y: gsap.getProperty(screens[i], "y"),
                        });
                    }
                }
                gsap.killTweensOf(".js-draggable");
            },
            onDrag: function () {
                let i = companions.length,
                    deltaX = this.x - MainRoom.prototype.startX,
                    deltaY = this.y - MainRoom.prototype.startY,
                    companion;
                while (--i > -1) {
                    companion = companions[i];
                    gsap.set(companion.element, {
                        x: companion.x + deltaX,
                        y: companion.y + deltaY,
                    });
                }
            },
        });
    }

    updateRoomRequirements() {
        const rooms = CONFIG.game.rooms;

        // @ts-ignore
        const lastChallenge = rooms.findLast(
            // @ts-ignore
            (item) => item.hotspot_type === "challenge",
        );
        const lastChallengeId = lastChallenge.id;

        $.each(rooms, (index, room) => {
            const requirements = room.requirements;
            const $roomItem = $(`.js-mainroom-item[data-page="${room.id}"]`);

            if (!requirements.length) {
                $roomItem.addClass("is-unlocked");
                return true;
            }

            let isLocked = false;
            $.each(requirements, (index, roomID) => {
                const roomStatus = getRoomStatus(roomID);

                if (roomStatus !== "is-status-completed") {
                    isLocked = true;
                    return false;
                }
            });

            isLocked
                ? $roomItem.addClass("is-locked").prop("disabled", true)
                : $roomItem.addClass("is-unlocked").prop("disabled", false);

            /**
             * if the last challenge is unlocked,
             * add class to create high alert animation before enter last challenge
             */
            if (room.id === lastChallengeId && !isLocked) {
                $(".js-mainroom-item").addClass("is-in-last-challenge");
                $(".transitionPage").addClass("is-last-challenge");
                $(".js-mainroom").addClass(
                    "is-at-last-challenge is-last-challenge-unlocked",
                );
            }
        });
    }

    finishGame(e, el) {
        const $el = $(el);
        const roomID = this.roomId;
        const gameProgress = getState().gameProgress;
        const waitingText = $(".waiting-others-text").text();

        if (gameProgress.allRoomCompleted && !$el.hasClass("is-waiting")) {
            $el.addClass("is-waiting");
            $el.find("span").text(waitingText);

            updateFinalRoomAnswer(roomID, {
                [CONFIG.user.id]: CONFIG.user.id,
            });
        }
    }

    finishedUsersListener(snapshot) {
        const value = snapshot.val();
        const readyUsers = bdjs.indexedObjectToArray(value);
        const players = getPlayers();

        if (readyUsers.length) {
            let allReady = true;

            players.forEach((player) => {
                const isReady = readyUsers.find((id) => id == player.userId);
                if (player.isOnline && !isReady) allReady = false;
            });

            if (allReady) {
                bdjs.goAsync(
                    bdapi.post("game/finish-game", {
                        middle_state: getState().gameProgress.isMiddleState
                            ? 1
                            : 0,
                        is_over_budget: getState().gameProgress.isOverBudget
                            ? 1
                            : 0,
                    }),
                );
            }
        }
    }

    maybeReadyToFinish() {
        const roomID = this.roomId;
        fb.get(`${fb.roomsPath}/${roomID}/finalAnswers`).then((data) => {
            this.finishedUsersListener(data);
        });
    }

    listenFinishedUsers() {
        const roomID = this.roomId;
        const path = `${fb.roomsPath}/${roomID}/finalAnswers`;

        this.fbListeners.push(
            fb.onValue(path, this.finishedUsersListener),
            fb.onValue(fb.playersPath, this.maybeReadyToFinish.bind(this)),
        );
    }

    beforeDestroy() {
        this.fbListeners.forEach((fn) => fn.call());
        this.fbListeners = [];
    }

    onClickedHint(e, el) {
        const elms = this.elms;
        const thisId = $(el).attr("id");
        const hintHotspots = $(elms.hintItem);

        $.each(hintHotspots, (index, item) => {
            const $item = $(item);
            const itemID = $item.attr("id");

            if (itemID !== thisId) {
                $item.prop("checked", false);
            }
        });
    }

    onClickAudio(e, el) {
        const elms = this.elms;
        const thisId = $(el).attr("id");
        const audioHotspot = $(elms.audioItem);

        $(elms.hintItem).prop("checked", false);

        const currentAudioID = "#" + thisId.split("audio-")[1];
        const $currAudio = $(currentAudioID).get(0);
        const isPlaying = $(el).hasClass("is-playing");

        // @ts-ignore
        isPlaying ? $currAudio.pause() : $currAudio.play();

        $(el).toggleClass("is-paused", isPlaying);
        $(el).toggleClass("is-playing", !isPlaying);

        $.each(audioHotspot, (index, item) => {
            const $item = $(item);
            const itemID = $item.attr("id");

            const audioID = "#" + itemID.split("audio-")[1];
            const $audio = $(audioID).get(0);

            if (itemID !== thisId) {
                // @ts-ignore
                if ($audio.play()) $audio.pause();

                $item.addClass("is-paused");
                $item.removeClass("is-playing");
            }
        });
    }

    forceOpenChallenge() {
        const data = this._data;
        const rooms = data.rooms;

        if (rooms.length) {
            for (const room of rooms) {
                const roomId = room.room;
                const status = getRoomStatus(roomId);

                if (
                    status === "is-status-completed" ||
                    !room.force_open_challenge
                ) {
                    continue;
                }

                const mainroomId = roomId;
                GameLogic.goToPage(mainroomId);
                break;
            }
        }
    }
}
